/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { getNameClient } from '../../helpers/nameClient';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { changeTitleBanner } from '../../store/actions';
import usePageTitle from '../../common/hooks/usePageTitle';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';

const Iframe = (props: any) => {
    const dispatch = useDispatch();
    const { id } = useParams<any>();
    const PageTitleRolM = usePageTitle(props.location.pathname);
    const [state, setState] = useState<any>({ currentIframe: undefined });

    useEffect(() => {
        const permissions = JSON.parse(String(localStorage.getItem('permisos')));
        const currentIframe = permissions.find((item: any) => item.id == id);

        if (currentIframe && currentIframe.identificator === "iFrame") {
            dispatch(changeTitleBanner(currentIframe.nombre));
            setState({ ...state, currentIframe });
        } else {
            dispatch(changeTitleBanner("No valid Iframe select"));
        }
    }, [id]);

    return (
        <React.Fragment>

            <PageTitle>
                <title>{PageTitleRolM.replace(/-/g, ' ')} | {getNameClient()}</title>
            </PageTitle>
            {state.currentIframe ?
                (state.currentIframe?.code ?
                    (
                        <div className='pt-5 mt-4 pe-1' dangerouslySetInnerHTML={{ __html: state.currentIframe.code }} />
                    ) :
                    <div className='pt-5 mt-5'>
                        <div className='d-flex justify-content-center align-items-center'>
                            <div>
                                Invalid Iframe Code
                            </div>
                        </div>
                    </div>
                )
                :
                <div className='pt-5 mt-5'>
                    <div className='d-flex justify-content-center align-items-center'>
                        <div>
                            <i style={{ fontSize: 150 }} className={`bx bx-error`}></i>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
};

export default Iframe;
